
<div class="appShell">
  <router-outlet></router-outlet>
</div>


<app-chat-flotante></app-chat-flotante>